// ---------------------------------------------- modules import
import React, { FunctionComponent } from "react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";

import AddForm from "./addForm";
import Details from "./details";
import List from "./list";
import ReaderList from "./readerList";
import UpdateForm from "./updateForm";

import { IPostProps } from "./common";
import { useAuth } from "./hooks";
import PermissionHelper from "../../../store/helpers/permissionHelper";

// ---------------------------------------------- the component
const Post: FunctionComponent<IPostProps> = ({ menuIndex }) => {
  // ---------------------------------------------- router state
  let match = useRouteMatch();

  // ---------------------------------------------- local state
  const { profile, areLoaded, isEmptied } = useAuth();

  // ---------------------------------------------- content
  return !areLoaded ? null : isEmptied ||
    !match ||
    !PermissionHelper.getView(profile.permissions, menuIndex) ? (
    <Redirect to="/login" />
  ) : (
    <>
      <Route
        exact
        path={match.path}
        render={props => <List {...props} menuIndex={menuIndex}></List>}
      />

      <Switch>
        <Route
          path={`${match.path}/add`}
          render={props => <AddForm {...props} menuIndex={menuIndex}></AddForm>}
        />

        <Route
          path={`${match.path}/update/:post_id`}
          render={props => (
            <UpdateForm {...props} menuIndex={menuIndex}></UpdateForm>
          )}
        />

        <Route
          path={`${match.path}/reader-list/:post_id`}
          render={props => (
            <ReaderList {...props} menuIndex={menuIndex}></ReaderList>
          )}
        />

        <Route
          path={`${match.path}/:post_id`}
          render={props => <Details {...props} menuIndex={menuIndex}></Details>}
        />
      </Switch>
    </>
  );
};

export default Post;
